import React from "react";
import ProjectCard from "../../components/Project/ProjectCard";
import projectList from "./projectList";
// const ProjectMain = () => {
//   // Example data
//   // const projectsData = [
//   //   // {
//   //   //   id: 1,
//   //   //   category: "Circular Elevators",
//   //   //   title: "Delivering success through logistics",
//   //   //   content: "Diverse Solutions, One Trusted Team",
//   //   //   link: "/project-details",
//   //   // },
//   //   {
//   //     id: 2,
//   //     image: projectImg1,
//   //     category: "Circular Elevators",
//   //     title: "360° of smooth elevation",
//   //     link: "/project-details/circular-lift",
//   //   },
//   //   {
//   //     id: 3,
//   //     image: projectImg2,
//   //     category: "Passenger Elevators",
//   //     title: "Comfort meets convenience with care",
//   //     link: "/project-details",
//   //   },
//   //   {
//   //     id: 4,
//   //     image: projectImg3,
//   //     category: "Hydraulic Elevators",
//   //     title: "Hydraulic power, seamless ride.",
//   //     link: "/project-details",
//   //   },
//   //   {
//   //     id: 5,
//   //     image: projectImg4,
//   //     category: "Home Elevators",
//   //     title: "Delivering success through logistics",
//   //     link: "/project-details",
//   //   },
//   //   {
//   //     id: 6,
//   //     image: projectImg5,
//   //     category: "Hospital Elevators",
//   //     title: "Healing journeys made smoother",
//   //     link: "/project-details",
//   //   },
//   //   {
//   //     id: 7,
//   //     image: projectImg5,
//   //     category: "Service Elevators",
//   //     title: "Elevating your service standards.",
//   //     link: "/project-details",
//   //   },
//   //   {
//   //     id: 8,
//   //     image: projectImg5,
//   //     category: "Goods Elevators",
//   //     title: "Built to move heavy loads with efficiency",
//   //     link: "/project-details",
//   //   },
//   //   {
//   //     id: 9,
//   //     image: projectImg5,
//   //     category: "Car Elevators",
//   //     title: "Lift Your Parking Worries Away with Car Elevators!",
//   //     link: "/project-details",
//   //   },
//   //   {
//   //     id: 10,
//   //     image: projectImg5,
//   //     category: "Stack Parking",
//   //     title: "Space-Saving Solutions for Urban Living!",
//   //     link: "/project-details",
//   //   },
//   //   // Add more project data here as needed
//   // ];

//   return (
//     <React.Fragment>
//       {/*Project Page Start*/}
//       <ProjectCard projects={projectsData} />
//       {/*Project Page End*/}
//     </React.Fragment>
//   );
// };

const ProjectMain = () => {
  var projectsData = projectList.map((item, index) => ({
    id: index + 1,
    image: item.basicInfo.image,
    content: item.basicInfo.content,
    category: item.basicInfo.liftType,
    title: item.details.title,
    link: `/elevator-details/${item.id}`,
  }));
  

  
  return <ProjectCard projects={projectsData} />;
};



export default ProjectMain;
